import React, { Suspense } from 'react'
import './App.css';
import './header.css';
import AppRouter from './modules/router/AppRouter';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

import { I18nextProvider } from 'react-i18next';
import i18n from './lang/i18n';
import { Provider } from 'react-redux';
import store from './modules/redux/store';
import Fallback from './modules/widgets/splash/Fallback';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const App = () => {
	const appLang = localStorage.getItem('lang');
	const lang = appLang === null ? 'en' : appLang;
	const rtlLangs = ['ar', 'he'];
	document.documentElement.lang = lang;
	document.documentElement.dir = rtlLangs.includes(lang) ? 'rtl' : 'ltr';
	document.getElementById('root').classList.add(lang);
	const queryClient = new QueryClient();

	return (
		<Provider store={store}>
			<Suspense fallback={<Fallback />}>
				<QueryClientProvider client={queryClient}>
					<I18nextProvider i18n={i18n}>
						<AppRouter />
					</I18nextProvider>
				</QueryClientProvider>
			</Suspense>
		</Provider>
	)
}
export default App
